module.exports = __webpack_public_path__ + "img/11_paul_s.68d8bf9f.png";